import * as React from "react";
const SvgChevronUp = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.835 11.317a.508.508 0 0 0 .832-.574l-.052-.076L8.78 4.865a1.015 1.015 0 0 0-1.472-.092l-.088.092-4.835 5.802a.508.508 0 0 0 .715.715l.065-.065L8 5.515l4.835 5.802Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  )
);
const SvgChevronUp$1 = SvgChevronUp;
export {
  SvgChevronUp$1 as default
};
